<script lang="ts">
    import { mdiTrashCanOutline } from "@mdi/js"
    import Icon from "../../Icon.svelte"
    import { actionApproval, login, newNotification } from "../../../store"
    import { deleteDBEntry } from "../../../../api"
    import { createEventDispatcher } from "svelte"
    const dispatch = createEventDispatcher()
    export let task: Task

    function deleteTask() {
        deleteDBEntry("task", task.id).then(() => {
            newNotification({
                class: "success",
                html: "Einsatz erfolgreich gelöscht.",
            })
            dispatch("taskDeleted")
        })
    }
</script>

<div class="actions">
    <button
        on:click|stopPropagation|preventDefault="{() => {
            if (!$login?.user?.roles?.includes('admin')) {
                newNotification({
                    class: 'error',
                    html: 'Sie haben keine Berechtigung, um diesen Einsatz zu löschen.',
                })
            }
            $actionApproval = {
                modalTitle: 'Eintrag löschen',
                modalText: 'Sind Sie sich sicher, dass Sie diesen Einsatz endgültig löschen möchten?',
                callback: () => {
                    deleteTask()
                },
            }
        }}"
    >
        <Icon path="{mdiTrashCanOutline}" />
    </button>
</div>

<style lang="less">
    .actions {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        button {
            color: var(--text-100);
        }
    }
</style>
